var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var StyledInlineInstallmentCalculator = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  line-height: 1.1rem;\n  text-decoration: underline;\n  margin: 0;\n  width: 100%;\n  text-align: center;\n  color: #282829;\n"], ["\n  cursor: pointer;\n  line-height: 1.1rem;\n  text-decoration: underline;\n  margin: 0;\n  width: 100%;\n  text-align: center;\n  color: #282829;\n"])));
/**
 * This is the installment calculator inline component.
 * By clicking on the component a modalbox opens which enables the user to configure values like the amount of installment rates
 * as well as if a payment pause (if available) should be used. The modalbox also provides a configurable option if the price
 * should be editable or not. If a value changes the installment calculator API will be called again and the values will be
 * updated according to the newly calculated values returned from the API call.
 */
export var InlineElement = function (_a) {
    var children = _a.children, onClick = _a.onClick;
    return (React.createElement(StyledInlineInstallmentCalculator, { "data-testid": "inline-installment-calculator-element", onClick: function () { return onClick(); } }, children));
};
export default InlineElement;
var templateObject_1;
//# sourceMappingURL=index.js.map